import {
  Box,
  Heading,
  RadioGroup,
  RadioItem,
  Stack,
  Textarea,
} from 'braid-design-system';
import slugify from 'slugify';

import { whatsPossibleLinks } from 'src/routes';

import { CheckboxGroup } from '../CheckboxGroup/CheckboxGroup';
import { ExternalLink } from '../ExternalLink';

import { useFormFields } from './useFormFields';

export const IntegrationDetails = () => {
  const {
    seekRsp,
    integrateToSeek,
    reasonForIntegration,
    currentlyIntegrated,
    solutions,
    whySeek,
  } = useFormFields();

  return (
    <Stack space="medium">
      <Box paddingTop="gutter">
        <Heading level="3">SEEK integration details</Heading>
      </Box>
      {seekRsp.value === 'no' && (
        <RadioGroup
          label="Are you a customer wanting to build an integration to SEEK?"
          id="integrateToSeek"
          {...integrateToSeek}
          onChange={({ currentTarget: { value } }) =>
            integrateToSeek.onChange(value as 'yes' | 'no')
          }
          value={integrateToSeek.value || ''}
        >
          <RadioItem label="Yes" value="yes" />
          <RadioItem label="No" value="no" />
        </RadioGroup>
      )}
      {integrateToSeek.value === 'no' && (
        <Textarea
          id="reasonForIntegration"
          label="Reason for completing this integration request"
          message={
            !reasonForIntegration.valid && reasonForIntegration.errorMessage
          }
          tone={!reasonForIntegration.valid ? 'critical' : 'neutral'}
          value={reasonForIntegration.value || ''}
          onChange={reasonForIntegration.onChange}
        />
      )}
      <RadioGroup
        label="Are you currently integrated with SEEK?"
        id="currentlyIntegrated"
        {...currentlyIntegrated}
        onChange={({ currentTarget: { value } }) =>
          currentlyIntegrated.onChange(value as 'yes' | 'no')
        }
      >
        <RadioItem label="Yes" value="yes" />
        <RadioItem label="No" value="no" />
      </RadioGroup>
      <CheckboxGroup
        {...solutions}
        id="solutions"
        label={
          currentlyIntegrated.value === 'yes'
            ? 'What additional SEEK solutions would you like to support?'
            : 'What SEEK solutions would you like to support?'
        }
        value={solutions.value}
        options={whatsPossibleLinks.map(({ name, path }) => ({
          badge: (
            <ExternalLink
              href={path}
              tracking={`${slugify(name, { lower: true })}-link-clicked`}
            />
          ),
          value: name,
        }))}
        error={!solutions.valid}
        description="To integrate with SEEK Job Posting, partners must also support SEEK Optimised Apply."
      />
      <Textarea
        id="whySeek"
        label="Please describe why you want to integrate with SEEK"
        message={!whySeek.valid && whySeek.errorMessage}
        tone={!whySeek.valid ? 'critical' : 'neutral'}
        value={whySeek.value}
        onChange={whySeek.onChange}
      />
    </Stack>
  );
};
